let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhU37")).then(() => parcelRequire('ejcQh'));